import React from 'react';
import { INavigationItemProps } from '../../ui-toolkit';

type NavigationChild = undefined | null | React.ReactElement<INavigationItemProps>;

export const SubNavigationTW: React.FC<{
  children?: NavigationChild | NavigationChild[];
}> = ({ children }) => {
  return <div className={'flex items-center justify-start gap-4 space-x-4 text-center'}>{children}</div>;
};
